/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import { logger } from "../../../utils/logger";
import { PTAX_REPORT_STATE } from "./ptax-report-constant";

const usePtaxReportService = () => {
	const [ptaxReportTableUILoading, setPtaxReportTableUILoading] = useState(false);
	const [ptaxDetails, setPtaxDetails] = useState({});
	const [ptaxOrgDetails, setPtaxOrgDetails] = useState({});
	const [ptaxResponseData, setPtaxResponseData] = useState({});
	const [restructuredPTaxData, setRestructuredPTaxData] = useState([]);
	const [ptaxReportListData, setPtaxReportListData] = useState([]);
	const { fetchData } = useAPIHandler()
	const [allowances, setAllowances] = useState([])
	const [ptaxReportInputs, setPtaxReportInputs] = useState(PTAX_REPORT_STATE)
	const [openUploadImportModal, setOpenUploadImportModal] = useState(false);
	const handleCloseUploadImportModal = () => setOpenUploadImportModal(false);
	const handleOpenUploadImportModal = () => setOpenUploadImportModal(true);
	const [monthlyPtaxSummary, setMonthlyPtaxSummary] = useState([]);
	const { session } = ptaxReportInputs;
	const parts = session.split("-");
	// const year = parts[0];
	// const nextYear = parts[1];
	const currentYear = parts[0];
	const nexttYear = parts[1];

	const handleChange = (e, name) => {
		let value = e;
		if (e && e.target) {
			value = e.target.value;
			name = e.target.name
		}
		setPtaxReportInputs((prevInfo) => ({
			...prevInfo,
			[name]: value
		}))
	}

	const getMonthlyPtaxSummary = (ptaxReportListData) => {
		const monthlyMap = new Map();

		// Initialize data for months 1 to 12
		for (let i = 1; i <= 12; i++) {
			monthlyMap.set(i, {
				month: i,
				totalEmloyeeCountWhoPayPtax: 0,
				totalPtaxAmountForThisMonth: 0,
			});
		}

		Object.entries(ptaxReportListData).forEach(([key, count]) => {
			const [monthStr, year, ptaxAmountStr] = key.split("-");
			const month = parseInt(monthStr, 10);
			const ptaxAmount = parseInt(ptaxAmountStr, 10);

			if (ptaxAmount > 0 && monthlyMap.has(month)) {
				const monthData = monthlyMap.get(month);
				monthData.totalEmloyeeCountWhoPayPtax += count;
				monthData.totalPtaxAmountForThisMonth += ptaxAmount * count;
			}
		});

		// Reorder: April (4) to March (3)
		const reorderedMonths = [
			...Array.from(monthlyMap.values()).filter(m => m.month >= 4),
			...Array.from(monthlyMap.values()).filter(m => m.month < 4),
		];

		return reorderedMonths;
	};

	const fetchAllPtaxReportEmpList = async () => {
		setPtaxReportTableUILoading(true);
		try {
			const { session } = ptaxReportInputs;
			logger.log("session999", session)
			if (session) {
				// const parts = session.split("-");
				// const year = parts[0];
				// const nextYear = parts[1];
				const response = await fetchData({
					url: `/report/yearly_ptax?year=${currentYear}&nextYear=${nexttYear}`,
					method: 'GET'
				});
				setPtaxResponseData(response?.data);
				setPtaxDetails(response?.data?.getOrgDetails);
				setPtaxReportListData(response?.data?.ptaxCalculationData);
				const restructured = await getRestructuredPtaxData(response?.data?.ptaxCalculationData, response?.data?.ptaxDetails);
				setRestructuredPTaxData(restructured);
				const dData = getMonthlyPtaxSummary(ptaxReportListData)
				setMonthlyPtaxSummary(dData)
			}
			setPtaxReportTableUILoading(false)
		} catch {
			setPtaxReportTableUILoading(false)
		}
	}
	const fetchOrgDetailFromEPFReport = async () => {
		setPtaxReportTableUILoading(true);
		try {
			const response = await fetchData({
				url: `/report/epf?month=1&year=2025&pageLimit=25&page=1&search=`,
				method: 'GET'
			});
			setPtaxOrgDetails(response?.data?.org_details);
			setPtaxReportTableUILoading(false)
		} catch {
			setPtaxReportTableUILoading(false)
		}
	}

	useEffect(() => {
		fetchAllPtaxReportEmpList();
		fetchOrgDetailFromEPFReport()
	}, [ptaxReportInputs])

	logger.log(ptaxResponseData, "ptaxResponseData000");

	const monthNames = [
		"January", "February", "March", "April", "May", "June",
		"July", "August", "September", "October", "November", "December"
	];

	const getRestructuredPtaxData = (ptaxCalculationData, ptaxDetails) => {
		const { tax_cal, year, to_year } = ptaxDetails;

		const monthMap = new Map();

		for (let i = 4; i <= 15; i++) {
			const month = ((i - 1) % 12) + 1;
			const yearForMonth = i <= 12 ? currentYear : nexttYear;
			const monthName = monthNames[month - 1];

			const slabs = tax_cal.map((slab) => {
				const min = slab.min_salary ?? 0;
				const max = slab.max_salary;
				const label = max
					? `${min}-${max}`
					: `${min}- rest`;
				return {
					taxSlab: label,
					ptaxAmount: slab.tax_amount,
					noOfEmployee: 0,
					totalAmount: 0
				};
			});

			const monthData = {
				month: monthName,
				year: yearForMonth,
				data: slabs
			};

			monthMap.set(`${month}-${yearForMonth}`, monthData);
		}

		Object.entries(ptaxCalculationData).forEach(([key, count]) => {
			const [monthStr, yearStr, ptaxAmountStr] = key.split("-");
			const keyStr = `${parseInt(monthStr, 10)}-${yearStr}`;
			const ptaxAmount = parseInt(ptaxAmountStr, 10);

			const monthEntry = monthMap.get(keyStr);
			if (monthEntry) {
				const slab = monthEntry.data.find(s => s.ptaxAmount === ptaxAmount);
				if (slab) {
					slab.noOfEmployee += count;
					slab.totalAmount += count * ptaxAmount;
				}
			}
		});

		return Array.from(monthMap.values());
	};

	useEffect(() => {
		if (ptaxReportListData && Object.keys(ptaxReportListData).length > 0) {
			const dData = getMonthlyPtaxSummary(ptaxReportListData);
			setMonthlyPtaxSummary(dData);
		}
	}, [ptaxReportListData]);

	useEffect(() => {
		if (restructuredPTaxData?.length) {
			logger.log(restructuredPTaxData, "restructuredPTaxData");
		}
	}, [restructuredPTaxData]);

	return {
		ptaxReportListData,
		ptaxReportInputs,
		handleChange,
		allowances,
		openUploadImportModal,
		handleCloseUploadImportModal,
		handleOpenUploadImportModal,
		monthlyPtaxSummary,
		ptaxReportTableUILoading,
		restructuredPTaxData,
		ptaxDetails,
		ptaxOrgDetails,
		currentYear,
		nexttYear
	}
}

export default usePtaxReportService